import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import CategoryNavSection from './components/CategoryNavSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { categories } from '@/mocks/categories';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫网',
  url: 'http://h8wx1.com/',
  description: '韩漫网提供韩国漫画全集免费阅读，支持下拉式在线浏览，让您畅读好看的韩漫大全。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://h8wx1.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-Hans',
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫网',
  url: 'http://h8wx1.com/',
  description: '韩漫网提供韩国漫画全集免费阅读，支持下拉式在线浏览，是中文韩漫阅读首选平台。',
  email: 'hello@h8wx1.com',
  foundingDate: '2023',
  logo: 'http://h8wx1.com/logo.png',
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '韩漫网的漫画都是免费的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，韩漫网上所有韩国漫画资源均为完全免费阅读，无需付费订阅，支持下拉式在线浏览，手机和电脑均可流畅阅读。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网有哪些漫画分类？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: `韩漫网目前提供${categories.length}大类韩国漫画：${categories.map((c) => c.name).join('、')}等，共计超过2000部作品，覆盖热门韩漫全部类型。`,
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫网编辑团队每日更新，热门连载韩漫第一时间同步更新，确保读者追更永不错过。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网支持哪些设备阅读？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫网全面支持PC端、手机端和平板设备访问，采用下拉式阅读设计，在移动端单手操作即可流畅翻页。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <title>韩国漫画全集免费_韩漫在线阅读下拉式_好看的韩国漫画大全-韩漫网</title>
      <meta name="description" content="韩漫网提供韩国漫画全集免费阅读，支持下拉式在线浏览，让您畅读好看的韩漫大全，体验无缝的阅读服务，随时随地探索热门作品并享受故事乐趣。" />
      <meta name="keywords" content="韩国漫画全集免费,在线阅读下拉式,好看漫画大全,韩漫网,韩国漫画,韩漫在线,免费漫画" />
      <link rel="canonical" href="http://h8wx1.com/" />
      <meta name="last-modified" content="2026-07-03" />
      <meta property="og:title" content="韩国漫画全集免费_韩漫在线阅读下拉式_好看的韩国漫画大全-韩漫网" />
      <meta property="og:description" content="韩漫网提供韩国漫画全集免费阅读，支持下拉式在线浏览，让您畅读好看的韩漫大全，体验无缝的阅读服务，随时随地探索热门作品并享受故事乐趣。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="http://h8wx1.com/" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="韩国漫画全集免费_韩漫在线阅读下拉式_好看的韩国漫画大全-韩漫网" />
      <meta name="twitter:description" content="韩漫网提供韩国漫画全集免费阅读，支持下拉式在线浏览，让您畅读好看的韩漫大全，体验无缝的阅读服务，随时随地探索热门作品并享受故事乐趣。" />
      <Navbar />
      <main>
        <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
        <HeroSection />
        <FeaturedGrid />
        <CategoryNavSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}